/* eslint-disable react-hooks/exhaustive-deps */
import { Accordion } from 'ypf-pas-general-ui-components';
import { useState, useEffect } from 'react';
import PropTypes, { number } from 'prop-types';

import DeletePositionLineModal from '../Modals/DeletePositionLineModal';
import MonthlyPositionLinesContainer from '../MonthlyLinesContainer/MonthlyPositionLinesContainer';
import { TypeAndObjectImputationPermissions, WorkPartPermissions } from '../RequestDetailTypes';

import RightContentAccordion from './RightContentAccordion';
import LeftContentAccordion from './LeftContentAccordion';
import './CustomAccordion.scss';

const PositionLineAccordion = ({
  accordionData,
  accordionsSelecteds,
  closeAccordions,
  handleOpenAccordion,
  month,
  IOPermissions,
  setAccordionsSelecteds,
  setRefreshFetch,
  setShowAddUbicationsToPLModal,
  workPartPermissions,
  year,
  disabledEditStateCancelOrFinish,
  isOyM,
  notificaPP
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showContentAccordion, setShowContentAccordion] = useState(false);

  const isPositionLineSelected = () => accordionsSelecteds.includes(accordionData?.id);

  const handleOnChange = () => {
    setAccordionsSelecteds(
      isPositionLineSelected()
        ? accordionsSelecteds.filter((id) => id !== accordionData?.id)
        : [...accordionsSelecteds, accordionData?.id]
    );
  };

  useEffect(() => {
    setShowContentAccordion(false);
  }, [accordionData]);

  useEffect(() => {
    handleOpenAccordion(showContentAccordion, accordionData?.id);
  }, [showContentAccordion]);

  useEffect(() => {
    if (closeAccordions) {
      setShowContentAccordion(false);
    }
  }, [closeAccordions]);

  return (
    <div className="custom-accordion">
      <Accordion
        availableManualOpening
        leftContent={
          <LeftContentAccordion
            hasTechnicalLocations={isOyM}
            id={accordionData?.id}
            isChecked={isPositionLineSelected()}
            lineName={`
              ${accordionData?.numeroLinea} - ${accordionData?.descripcionLineaSap}`}
            onChange={handleOnChange}
            positionName={`
              ${accordionData?.numeroPosicion} - ${accordionData?.descripcionPosicionSap}`}
            unitMeasure={accordionData?.unidadMedida}
          />
        }
        restrictedOpening
        rightContent={
          <RightContentAccordion
            IOPermissions={IOPermissions}
            disabledDeleteAction={!workPartPermissions.deletePositionLine}
            isOrderByUbication={false}
            setShowDeleteModal={setShowDeleteModal}
          />
        }
        setShowManualContent={setShowContentAccordion}
        showManualContent={showContentAccordion}
        width="100%"
      >
        <MonthlyPositionLinesContainer
          accordionData={accordionData}
          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
          hasPermissionsToAddUbication={workPartPermissions.addUbication}
          isOyM={isOyM}
          lineName={accordionData?.descripcionLineaSap}
          month={month}
          notificaPP={notificaPP}
          positionLinePermissions={workPartPermissions.positionLine}
          positionName={accordionData?.descripcionPosicionSap}
          setAccordionsSelecteds={setAccordionsSelecteds}
          setRefreshFetch={setRefreshFetch}
          setShowAddUbicationsToPLModal={setShowAddUbicationsToPLModal}
          showContentAccordion={showContentAccordion}
          unitMeasure={accordionData?.unidadMedida}
          year={year}
        />
      </Accordion>
      <DeletePositionLineModal
        line={accordionData?.descripcionLineaSap}
        position={accordionData?.descripcionPosicionSap}
        positionLineId={accordionData?.id}
        setRefreshFetch={setRefreshFetch}
        setShowDeleteModal={setShowDeleteModal}
        showDeleteModal={showDeleteModal}
      />
    </div>
  );
};

PositionLineAccordion.propTypes = {
  accordionData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    descripcionPosicionSap: PropTypes.string.isRequired,
    descripcionLineaSap: PropTypes.string.isRequired,
    descripcionPosicionYClic: PropTypes.string.isRequired,
    descripcionLineaYClic: PropTypes.string.isRequired,
    numeroLinea: PropTypes.number.isRequired,
    numeroPosicion: PropTypes.number.isRequired,
    unidadMedida: PropTypes.string.isRequired
  }).isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  accordionsSelecteds: PropTypes.arrayOf(number).isRequired,
  closeAccordions: PropTypes.bool.isRequired,
  handleOpenAccordion: PropTypes.func.isRequired,
  IOPermissions: TypeAndObjectImputationPermissions.isRequired,
  month: PropTypes.string.isRequired,
  setAccordionsSelecteds: PropTypes.func.isRequired,
  setRefreshFetch: PropTypes.func.isRequired,
  setShowAddUbicationsToPLModal: PropTypes.func.isRequired,
  workPartPermissions: WorkPartPermissions.isRequired,
  year: PropTypes.string.isRequired,
  isOyM: PropTypes.bool,
  notificaPP: PropTypes.bool.isRequired
};

PositionLineAccordion.defaultProps = {
  isOyM: false
};

export default PositionLineAccordion;
